import {Box, Button, Divider, FormControl, FormLabel} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import GlobalDateField from "../../global-fields/GlobalDateField";
import {Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalRadio from "../../global-fields/GlobalRadio";
import GlobalTextField from "../../global-fields/GlobalTextField";
import {useFormik} from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {setUiData} from "../../../store/uiSlice";
import {PROPOSAL_FORM} from "../../../constants/apiConstant";
import {
  normalizeCurrencyToNumber,
  areRequiredFieldsFilled,
  handleFileUploadWithoutVids,
  parseToNumber,
  removeCookies,
  USD_FORMATTER,
  initialFormValidations,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {MANDATORY_QUES} from "../../../constants/constants";
import GlobalErrorMsgBox from "../../global-fields/GlobalErrorMsgBox";
import {motion} from "framer-motion";
import {fadeSlideIn} from "../../../constants/motionConstants";
import {FaExternalLinkAlt} from "react-icons/fa";
import dayjs from "dayjs";
import {
  amountSchemaWithoutRequired,
  numberSchemaWithoutRequired,
} from "../../../constants/validationSchemas";
import {MdOutlineRemoveRedEye} from "react-icons/md";
import {TbRefresh} from "react-icons/tb";
import GlobalCheckBox from "../../global-fields/GlobalCheckBox";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const StepTenForm = ({leftGridWidth}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, selectedClient} = useSelector(selectAuthState);
  // const { submitConfirmModal } = useSelector(selectUiState);
  const {
    proposalStep,
    propStep10Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const propStep10DataMemoize = useMemo(() => propStep10Data, [propStep10Data]);
  const [disableDraft, setDisableDraft] = useState(false);

  const initialValues = {
    step: 10,
    not_applicable:
      propStep10DataMemoize?.not_applicable === "1" ||
      propStep10DataMemoize?.not_applicable === 1
        ? 1
        : 0,
    including_transits_shows:
      propStep10DataMemoize?.including_transits_shows ?? "",
    including_transits_limit:
      propStep10DataMemoize?.including_transits_limit == 0 ||
      propStep10DataMemoize?.including_transits_limit == "0" ||
      propStep10DataMemoize?.including_transits_limit
        ? USD_FORMATTER.format(propStep10DataMemoize?.including_transits_limit)
        : "",
    including_transits_aggregate_exposure:
      propStep10DataMemoize?.including_transits_aggregate_exposure == 0 ||
      propStep10DataMemoize?.including_transits_aggregate_exposure == "0" ||
      propStep10DataMemoize?.including_transits_aggregate_exposure
        ? USD_FORMATTER.format(
            propStep10DataMemoize?.including_transits_aggregate_exposure
          )
        : "",
    excluding_transits_shows:
      propStep10DataMemoize?.excluding_transits_shows ?? "",
    excluding_transits_limit:
      propStep10DataMemoize?.excluding_transits_limit == 0 ||
      propStep10DataMemoize?.excluding_transits_limit == "0" ||
      propStep10DataMemoize?.excluding_transits_limit
        ? USD_FORMATTER.format(propStep10DataMemoize?.excluding_transits_limit)
        : "",
    excluding_transits_aggregate_exposure:
      propStep10DataMemoize?.excluding_transits_aggregate_exposure == 0 ||
      propStep10DataMemoize?.excluding_transits_aggregate_exposure == "0" ||
      propStep10DataMemoize?.excluding_transits_aggregate_exposure
        ? USD_FORMATTER.format(
            propStep10DataMemoize?.excluding_transits_aggregate_exposure
          )
        : "",
    transit_by_armored_car: propStep10DataMemoize?.transit_by_armored_car ?? "",
   // two_person_warranty: propStep10DataMemoize?.two_person_warranty ?? "",
    // ul_certificate_no: propStep10DataMemoize?.ul_certificate_no ?? "",
    // expiry_date: propStep10DataMemoize?.expiry_date ?? "",
    // ul_certificate_file: propStep10DataMemoize?.ul_certificate_file ?? null, // File input
    // wearing_coverage_in_store_limit:
    //   propStep10DataMemoize?.wearing_coverage_in_store_limit == 0 ||
    //   propStep10DataMemoize?.wearing_coverage_in_store_limit == "0" ||
    //   propStep10DataMemoize?.wearing_coverage_in_store_limit
    //     ? USD_FORMATTER.format(
    //         propStep10DataMemoize?.wearing_coverage_in_store_limit
    //       )
    //     : "",
    // wearing_coverage_territorial_limit:
    //   propStep10DataMemoize?.wearing_coverage_territorial_limit == 0 ||
    //   propStep10DataMemoize?.wearing_coverage_territorial_limit == "0" ||
    //   propStep10DataMemoize?.wearing_coverage_territorial_limit
    //     ? USD_FORMATTER.format(
    //         propStep10DataMemoize?.wearing_coverage_territorial_limit
    //       )
    //     : "",
  };

  // useEffect(() => {
  //   if (propStep10DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep10DataMemoize]);

  const handleStepData = (e) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }
    dispatch(setUiData({showLoader: true}));

    let data = {
      ...e,
      user_id: user?.id,
      proposal_id,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
      step: proposalStep,
      expiry_date: e.expiry_date
        ? dayjs(e.expiry_date).format("MM-DD-YYYY")
        : "",
      including_transits_limit: normalizeCurrencyToNumber(
        e.including_transits_limit
      ),
      including_transits_aggregate_exposure: normalizeCurrencyToNumber(
        e.including_transits_aggregate_exposure
      ),
      excluding_transits_limit: normalizeCurrencyToNumber(
        e.excluding_transits_limit
      ),
      excluding_transits_aggregate_exposure: normalizeCurrencyToNumber(
        e.excluding_transits_aggregate_exposure
      ),
      // wearing_coverage_in_store_limit: normalizeCurrencyToNumber(
      //   e.wearing_coverage_in_store_limit
      // ),
      // wearing_coverage_territorial_limit: normalizeCurrencyToNumber(
      //   e.wearing_coverage_territorial_limit
      // ),
    };
    if (user?.user_type === "agent") {
      data = {...data, user_id: selectedClient?.user_id, agent_id: user?.id};
    }
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value instanceof File) {
        formData.append(key, value);
      } else if (value === null || value === undefined) {
        formData.append(key, ""); // or use "null" if your backend expects that
      } else {
        formData.append(key, value);
      }
    });

    const options = {
      method: PROPOSAL_FORM.method,
      body: formData,
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(setUiData({showLoader: false}));
          formik.resetForm();
        } else if (res.status == 1) {
          formik.resetForm();
          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(setUiData({showLoader: false}));
        navigate("/");
        formik.resetForm();
      });
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      not_applicable: Yup.number()
        .oneOf([1, 0], "Invalid selection")
        .required(MANDATORY_QUES),
      including_transits_shows: numberSchemaWithoutRequired,
      including_transits_limit: amountSchemaWithoutRequired,
      including_transits_aggregate_exposure: amountSchemaWithoutRequired,
      excluding_transits_shows: numberSchemaWithoutRequired,
      excluding_transits_limit: amountSchemaWithoutRequired,
      excluding_transits_aggregate_exposure: amountSchemaWithoutRequired,
      transit_by_armored_car: Yup.string()
        // .oneOf(["Yes", "No"], "Invalid selection")
        .notRequired(),
     // two_person_warranty: Yup.string()
        // .oneOf(["Yes", "No"], "Invalid selection")
      //  .notRequired(),
      // ul_certificate_no: Yup.string()
      //   .nullable()
      //   .max(33, "Maximum 32 Characters Allowed."),
      // expiry_date: Yup.string(),
      // ul_certificate_file: Yup.mixed()
      //   .nullable()
      //   .test("file-or-url", MANDATORY_QUES, (value) => {
      //     if (!value) return true; // No Validation
      //     // if (!value) return false; // If value is null/undefined, it's invalid
      //     if (typeof value === "string" && value.includes("https://"))
      //       return true; // Valid URL
      //     if (value instanceof File) return true; // Valid File
      //     return false; // Invalid case
      //   }),
      // wearing_coverage_in_store_limit: amountSchemaWithoutRequired,
      // wearing_coverage_territorial_limit: amountSchemaWithoutRequired,
    }),
    onSubmit: (values) => {
      //console.log("Form submitted 10:", values);
      handleStepData(values);
    },
  });

  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 10) {
          return {...item, status: 2};
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };

  // console.log("formik", formik.values, formik.errors);
  // console.log("formik", formik.dirty, formik.values, formik.errors);
  // console.log("propStep5DataMemoize", propStep5DataMemoize);
  const handleAmountFieldChangeOLD = (e, fieldName) => {
    const rawValue = e.target.value;
    const numericValue = parseToNumber(rawValue);
    formik.setFieldValue(
      fieldName,
      numericValue !== "" ? USD_FORMATTER.format(numericValue) : ""
    );
  };

  const handleAmountFieldChange = (e, fieldName) => {
    let rawValue = e.target.value;

    // Ensure it always starts with $
    if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

    // Extract numeric part
    const numericValue = parseToNumber(rawValue);

    // Allow typing "$" or "$." without formatting
    if (rawValue === "$" || rawValue === "$.") {
      formik.setFieldValue(fieldName, rawValue);
      return;
    }

    // Format integer part with commas, keep decimal part as typed
    let formatted = "$";
    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      // Format integer with commas
      formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));

      // Append decimal part if exists, limit to 2 digits
      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    formik.setFieldValue(fieldName, formatted);
  };

  // console.log("areRequiredFieldsFilled",areRequiredFieldsFilled(formik))

  const handleSaveDraft = useCallback(() => {
    const {values} = formik;
    setDisableDraft(true);
    let vals = {...values, save_draft: true};
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);

  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h2 className={style.propo_title}>Exhibition</h2>
            <h2 className={style.formTitleh2}>20) Exhibition Coverage</h2>
            <form
              autoComplete="false"
              autoSave="false"
              onSubmit={handleCustomSubmit}
            >
              <Grid container spacing={2} sx={{mt: 1}}>
                <Grid size={{xs: 12, lg: 5, md: 5, sm: 6, xl: 4}} sx={{mt: 1}}>
                  <GlobalCheckBox
                    title="Not Applicable"
                    selected={formik.values?.not_applicable == 1}
                    onClick={(e) => {
                      e.preventDefault();
                      formik.setFieldValue(
                        `not_applicable`,
                        formik.values?.not_applicable == 1 ? 0 : 1
                      );
                    }}
                    error={
                      formik.touched.not_applicable &&
                      Boolean(formik.errors.not_applicable)
                    }
                    errorText={
                      formik.touched.not_applicable &&
                      formik.errors.not_applicable
                    }
                  />
                </Grid>
              </Grid>
              <Box
                sx={
                  formik.values.not_applicable === 1
                    ? {
                        opacity: "0.5 !important",
                        pointerEvents: "none !important",
                      }
                    : {}
                }
              >
                <Grid container spacing={2} sx={{mt: 1}}>
                  <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                    <h3 className={style.htitleText}>Including Transits</h3>
                  </Grid>

                  <Grid size={{xs: 12, md: 4}}>
                    <FormControl fullWidth>
                      <FormLabel sx={{mb: 1}}> Number of Shows </FormLabel>
                    </FormControl>
                    <GlobalTextField
                      // placeH="$"
                      type="text"
                      name={`including_transits_shows`}
                      id={`_including_transits_shows`}
                      value={formik.values?.including_transits_shows}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.including_transits_shows &&
                        Boolean(formik.errors?.including_transits_shows)
                      }
                      helperText={
                        formik.touched?.including_transits_shows &&
                        formik.errors?.including_transits_shows
                      }
                    />
                  </Grid>
                  <Grid size={{xs: 12, md: 4}}>
                    <FormControl fullWidth>
                      <FormLabel sx={{mb: 1}}> Limit Required </FormLabel>
                    </FormControl>
                    <GlobalTextField
                      placeH="$"
                      type="text"
                      name={`including_transits_limit`}
                      id={`_including_transits_limit`}
                      value={formik.values?.including_transits_limit}
                      onChange={(e) =>
                        handleAmountFieldChange(e, "including_transits_limit")
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.including_transits_limit &&
                        Boolean(formik.errors?.including_transits_limit)
                      }
                      helperText={
                        formik.touched?.including_transits_limit &&
                        formik.errors?.including_transits_limit
                      }
                    />
                  </Grid>
                  <Grid size={{xs: 12, md: 4}}>
                    <FormControl fullWidth>
                      <FormLabel sx={{mb: 1}}> Aggregate Exposure </FormLabel>
                    </FormControl>
                    <GlobalTextField
                      placeH="$"
                      type="text"
                      name={`including_transits_aggregate_exposure`}
                      id={`_including_transits_aggregate_exposure`}
                      value={
                        formik.values?.including_transits_aggregate_exposure
                      }
                      onChange={(e) =>
                        handleAmountFieldChange(
                          e,
                          "including_transits_aggregate_exposure"
                        )
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.including_transits_aggregate_exposure &&
                        Boolean(
                          formik.errors?.including_transits_aggregate_exposure
                        )
                      }
                      helperText={
                        formik.touched?.including_transits_aggregate_exposure &&
                        formik.errors?.including_transits_aggregate_exposure
                      }
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} sx={{mt: 1}}>
                  <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                    <h3 className={style.htitleText}>Excluding Transits</h3>
                  </Grid>

                  <Grid size={{xs: 12, md: 4}}>
                    <FormControl fullWidth>
                      <FormLabel sx={{mb: 1}}> Number of Shows </FormLabel>
                    </FormControl>
                    <GlobalTextField
                      // placeH="$"
                      type="text"
                      name={`excluding_transits_shows`}
                      id={`_excluding_transits_shows`}
                      value={formik.values?.excluding_transits_shows}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.excluding_transits_shows &&
                        Boolean(formik.errors?.excluding_transits_shows)
                      }
                      helperText={
                        formik.touched?.excluding_transits_shows &&
                        formik.errors?.excluding_transits_shows
                      }
                    />
                  </Grid>
                  <Grid size={{xs: 12, md: 4}}>
                    <FormControl fullWidth>
                      <FormLabel sx={{mb: 1}}> Limit Required </FormLabel>
                    </FormControl>
                    <GlobalTextField
                      placeH="$"
                      type="text"
                      name={`excluding_transits_limit`}
                      id={`_excluding_transits_limit`}
                      value={formik.values?.excluding_transits_limit}
                      onChange={(e) =>
                        handleAmountFieldChange(e, "excluding_transits_limit")
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.excluding_transits_limit &&
                        Boolean(formik.errors?.excluding_transits_limit)
                      }
                      helperText={
                        formik.touched?.excluding_transits_limit &&
                        formik.errors?.excluding_transits_limit
                      }
                    />
                  </Grid>
                  <Grid size={{xs: 12, md: 4}}>
                    <FormControl fullWidth>
                      <FormLabel sx={{mb: 1}}> Aggregate Exposure </FormLabel>
                    </FormControl>
                    <GlobalTextField
                      placeH="$"
                      type="text"
                      name={`excluding_transits_aggregate_exposure`}
                      id={`_excluding_transits_aggregate_exposure`}
                      value={
                        formik.values?.excluding_transits_aggregate_exposure
                      }
                      onChange={(e) =>
                        handleAmountFieldChange(
                          e,
                          "excluding_transits_aggregate_exposure"
                        )
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.excluding_transits_aggregate_exposure &&
                        Boolean(
                          formik.errors?.excluding_transits_aggregate_exposure
                        )
                      }
                      helperText={
                        formik.touched?.excluding_transits_aggregate_exposure &&
                        formik.errors?.excluding_transits_aggregate_exposure
                      }
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} sx={{mt: {md: 3, xs: 2}}}>
                  <Grid size={{xs: 12, md: 12}}>
                    <Box sx={{color: "#000", mb: 0}}>
                      <h3 className={style.htitleText}>
                        Transit by Armored Car
                      </h3>
                    </Box>
                  </Grid>
                  <Grid size={{xs: 12, md: 4}}>
                    <GlobalRadio
                      title="Yes"
                      selected={formik.values.transit_by_armored_car === "Yes"}
                      onClick={(e) => {
                        e.preventDefault();
                        formik.setFieldValue("transit_by_armored_car", "Yes");
                      }}
                      error={
                        formik.touched.transit_by_armored_car &&
                        Boolean(formik.errors.transit_by_armored_car)
                      }
                      errorText={
                        formik.touched.transit_by_armored_car &&
                        formik.errors.transit_by_armored_car
                      }
                    />
                  </Grid>
                  <Grid size={{xs: 12, md: 4}}>
                    <GlobalRadio
                      title="No"
                      selected={formik.values.transit_by_armored_car === "No"}
                      onClick={(e) => {
                        e.preventDefault();
                        formik.setFieldValue("transit_by_armored_car", "No");
                      }}
                    />
                  </Grid>

                  {/* <Grid size={{xs: 12, md: 12}} sx={{mt: 1}}>
                    <Box sx={{color: "#000", mb: 0}}>
                      <h3 className={style.htitleText}>Two Person Warranty </h3>
                    </Box>
                  </Grid>
                  <Grid size={{xs: 12, md: 4}}>
                    <GlobalRadio
                      title="Yes"
                      selected={formik.values.two_person_warranty === "Yes"}
                      onClick={(e) => {
                        e.preventDefault();
                        formik.setFieldValue("two_person_warranty", "Yes");
                      }}
                      error={
                        formik.touched.two_person_warranty &&
                        Boolean(formik.errors.two_person_warranty)
                      }
                      errorText={
                        formik.touched.two_person_warranty &&
                        formik.errors.two_person_warranty
                      }
                    />
                  </Grid> */}
                  {/* <Grid size={{xs: 12, md: 4}}>
                    <GlobalRadio
                      title="No"
                      selected={formik.values.two_person_warranty === "No"}
                      onClick={(e) => {
                        e.preventDefault();
                        formik.setFieldValue("two_person_warranty", "No");
                      }}
                    />
                  </Grid> */}
                </Grid>
              </Box>

              {/* <Grid container spacing={2} sx={{mt: 3}}>
                <Grid size={{xs: 12, md: 4}}>
                  <Box sx={{color: "#000", mb: 1}}>
                    <h3 className={style.htitleText}>U.L. Certificate No.</h3>
                  </Box>
                  <GlobalTextField
                    name={`ul_certificate_no`}
                    id={`_ul_certificate_no`}
                    value={formik.values.ul_certificate_no}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.ul_certificate_no &&
                      Boolean(formik.errors.ul_certificate_no)
                    }
                    helperText={
                      formik.touched.ul_certificate_no &&
                      formik.errors.ul_certificate_no
                    }
                  />
                </Grid>

                <Grid size={{xs: 12, md: 4}}>
                  <Box sx={{color: "#000", mb: 1}}>
                    <h3 className={style.htitleText}>Date of Expiration</h3>
                  </Box>
                  <GlobalDateField
                    name={`expiry_date`}
                    value={formik.values.expiry_date}
                    onChange={(newValue) =>
                      formik.setFieldValue(`expiry_date`, newValue)
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.expiry_date &&
                      Boolean(formik.errors?.expiry_date)
                    }
                    helperText={
                      formik.touched?.expiry_date && formik.errors?.expiry_date
                    }
                    disablePast
                    clearBtn={formik.values.expiry_date !== ""}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mt: 3}}>
                <Grid size={{xs: 12, md: 8}} className="choosefileBtn">
                  <Box sx={{color: "#000", mb: 1}}>
                    <h3 className={style.htitleText}>
                      Enclose U.L. Certificates where issued
                    </h3>
                  </Box>
                  <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<CloudUploadIcon />}
                  >
                    {formik.values?.ul_certificate_file?.name ? (
                      <span> {formik.values?.ul_certificate_file.name} </span>
                    ) : formik.values?.ul_certificate_file?.includes(
                        "https://"
                      ) ? (
                      <>
                        <span className={style.safeVFile}>
                          {
                            formik.values?.ul_certificate_file.split(
                              "/images/"
                            )[1]
                          }
                        </span>
                      </>
                    ) : (
                      "Upload file"
                    )}
                    <VisuallyHiddenInput
                      type="file"
                      accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                      onChange={(event) =>
                        handleFileUploadWithoutVids({
                          event,
                          fieldName: `ul_certificate_file`,
                          formik,
                          onError: (message) =>
                            GlobalNotificationPopup({
                              type: "error",
                              message,
                            }),
                        })
                      }
                    />
                  </Button>

                  <div className={style.fileBtnMain}>
                    {formik.values?.ul_certificate_file &&
                    formik.values?.ul_certificate_file !== "" ? (
                      <>
                        <span
                          style={{
                            cursor: "pointer",
                            borderRadius: "10px",
                            color: "rgb(0 79 113)",
                            display: "block",
                            marginTop: "10px",
                            textAlign: "right",
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            if (formik.values?.ul_certificate_file?.name) {
                              window.open(
                                URL.createObjectURL(
                                  formik.values?.ul_certificate_file
                                ),
                                "_blank"
                              );
                              return;
                            }

                            if (
                              formik.values?.ul_certificate_file?.includes(
                                "https://"
                              )
                            ) {
                              window.open(
                                formik.values?.ul_certificate_file,
                                "_blank"
                              );
                            }
                            return;
                          }}
                        >
                          View <MdOutlineRemoveRedEye />
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            borderRadius: "10px",
                            color: "rgb(0 79 113)",
                            display: "block",
                            marginTop: "10px",
                            textAlign: "right",
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={() =>
                            formik.setFieldValue(`ul_certificate_file`, "")
                          }
                        >
                          Clear <TbRefresh />
                        </span>
                      </>
                    ) : null}
                  </div>
                  {formik.touched?.ul_certificate_file &&
                  formik?.errors?.ul_certificate_file ? (
                    <GlobalErrorMsgBox
                      errMessage={formik?.errors?.ul_certificate_file}
                    />
                  ) : null}
                </Grid>
              </Grid> */}

              {/* <Grid container spacing={2} sx={{mt: 1}}>
                <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                  <h3 className={style.htitleText}>Wearing Coverage</h3>
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                  <FormControl fullWidth>
                    <FormLabel sx={{mb: 1}}>Limit for in store only</FormLabel>
                  </FormControl>
                  <GlobalTextField
                    placeH="$"
                    type="text"
                    name={`wearing_coverage_in_store_limit`}
                    id={`_wearing_coverage_in_store_limit`}
                    value={formik.values?.wearing_coverage_in_store_limit}
                    onChange={(e) =>
                      handleAmountFieldChange(
                        e,
                        "wearing_coverage_in_store_limit"
                      )
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.wearing_coverage_in_store_limit &&
                      Boolean(formik.errors?.wearing_coverage_in_store_limit)
                    }
                    helperText={
                      formik.touched?.wearing_coverage_in_store_limit &&
                      formik.errors?.wearing_coverage_in_store_limit
                    }
                  />
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                  <FormControl fullWidth>
                    <FormLabel sx={{mb: 1}}>
                      Territorial Limits as per policy
                    </FormLabel>
                  </FormControl>
                  <GlobalTextField
                    placeH="$"
                    type="text"
                    name={`wearing_coverage_territorial_limit`}
                    id={`_wearing_coverage_territorial_limit`}
                    value={formik.values?.wearing_coverage_territorial_limit}
                    onChange={(e) =>
                      handleAmountFieldChange(
                        e,
                        "wearing_coverage_territorial_limit"
                      )
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.wearing_coverage_territorial_limit &&
                      Boolean(formik.errors?.wearing_coverage_territorial_limit)
                    }
                    helperText={
                      formik.touched?.wearing_coverage_territorial_limit &&
                      formik.errors?.wearing_coverage_territorial_limit
                    }
                  />
                </Grid>
              </Grid> */}
            </form>
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={
            formik.values.including_transits_shows !== "" &&
            formik.values.including_transits_limit !== "" &&
            formik.values.including_transits_aggregate_exposure !== "" &&
            formik.values.excluding_transits_shows !== "" &&
            formik.values.excluding_transits_limit !== "" &&
            formik.values.excluding_transits_aggregate_exposure !== "" &&
            formik.values.transit_by_armored_car !== "" &&
            // formik.values.two_person_warranty !== "" &&
            // areRequiredFieldsFilled(formik) &&
            !formik.dirty &&
            propStep10DataMemoize !== null
          }
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
      </section>
    </>
  );
};

export default StepTenForm;
